import moment from "moment";
import { CANCEL_BOOKING_FEE_CODE } from "../constants/variables";
import {
  CurrentBookingInState} from "../dataLayer/CurrentBookingInState";
import {
  addBookingInMyTripAPI,
  resetBookingAPI,
  getBookingDetails,
  getBookingDetailsWithUserInfo} from "../dataLayer/manageBooking";
import { getToken } from "../helper/token";
import {
  resetAddhos,
  setCurrentBookingInState,
  setInitBookingInState,
  resetPriceDiff
} from "../store/slices/booking";
import { getSeatMealRunningAddon } from "./fareCalcuation";

export function isBookingExpired(currentBookingInState) {
  try {
    const responseData = {
      status: true,
      data: {}
    };
    let isExpired = false;
    const todayDate = moment();
    if (currentBookingInState?.journeys) {
      for (let journeyInd = 0; journeyInd < currentBookingInState?.journeys.length; journeyInd += 1) {
        const journeyInfo = currentBookingInState?.journeys[journeyInd];
        const departureDate = moment(journeyInfo?.designator?.departure);
        const diffOfDate = departureDate.diff(todayDate, "minute");
        if (diffOfDate <= 0) {
          isExpired = true;
        } else {
          isExpired = false;
        }
      }
    }
    responseData.data.isExpired = isExpired;
    return responseData;
  } catch (error) {
    console.warn(error.message);
    const responseData = {
      status: false,
      code: 500,
      message: "Something went wrong",
      data: {
        isExpired: false
      }
    };
    return responseData;
  }
}

export function checkForHoldAmount(currentBookingV2) {
  try {
    let pendingAmount = 0;
    pendingAmount += (currentBookingV2?.priceDiff || 0);
    pendingAmount += (currentBookingV2?.currentBookingInState?.breakdown?.balanceDue || 0);

    const seatMealRunningAdon = getSeatMealRunningAddon(currentBookingV2);
    if (seatMealRunningAdon) {
      pendingAmount += seatMealRunningAdon.totalAmount;
    }

    const response = {
      status: true,
      data: {
        pendingAmount
      }
    };
    return response;
  } catch (error) {
    console.warn(error.message);
    const response = {
      status: false,
      data: {
        pendingAmount: 0
      }
    };
    return response;
  }
}

export async function addBookingInMyTrip() {
  try {
    const response = {
      status: true,
      data: {}
    };
    response.data = await addBookingInMyTripAPI();
    return response;
  } catch (error) {
    console.warn(error.message);
    const response = {
      status: false,
      data: {
        msg: error
      }
    };
    return response;
  }
}

/* below function is to get the lastname, pnr and email from the currentbookingInState */
export function getPNRandLastNameFromBooking(currentBookingInState) {
  try {
    const response = {
      status: true,
      data: {}
    };

    if (currentBookingInState) {
      response.data.pnr = currentBookingInState?.recordLocator;
      response.data.lastName = currentBookingInState?.contacts[0]?.name?.last;
      response.data.email = currentBookingInState?.contacts[0]?.emailAddress;
    }
    return response;
  } catch (error) {
    console.warn(error.message);
    const response = {
      status: false,
      data: {
        msg: error
      }
    };
    return response;
  }
}

/* below function is to get the firstName, lastname, pnr and email from the currentbookingInState specially for group booking */
export function getPNRandPaxDetailsFromGroupBooking(currentBookingInState) {
  try {
    const response = {
      status: true,
      data: {}
    };

    if (currentBookingInState) {
      response.data.pnr = currentBookingInState?.recordLocator;
      response.data.firstName = currentBookingInState?.passengers[0]?.name?.first;
      response.data.lastName = currentBookingInState?.passengers[0]?.name?.last;
    }
    return response;
  } catch (error) {
    console.warn(error.message);
    const response = {
      status: false,
      data: {
        msg: error
      }
    };
    return response;
  }
}

/* below function is to get the lastname, pnr and email from the currentbookingInState and reset booking for normal booking */
export async function resetBooking(currentBookingInState) {
  try {
    const response = {
      status: false,
      data: {}
    };
    if (currentBookingInState) {
      let isCancelFeeAdded = false;

      const ssrList = currentBookingInState.fees.length > 0 ? currentBookingInState.fees[0]?.value?.fees : [];
      const checkCancelAdhos = ssrList.filter((ssr) => ssr.code === CANCEL_BOOKING_FEE_CODE);
      if (checkCancelAdhos.length > 0) {
        isCancelFeeAdded = true;
      }
      if (currentBookingInState.journeys.length === 0) {
        isCancelFeeAdded = true;
      }
      if (currentBookingInState && isCancelFeeAdded) {
        response.status = true;
        await resetBookingAPI();
        await getToken(true);
        const bookingData = getPNRandLastNameFromBooking(currentBookingInState);
        const params = {
          pnrDetails: bookingData.data.pnr,
          lastName: bookingData.data.lastName,
          email: bookingData.data.email
        };

        response.data = await getBookingDetails(params);
      }
    }

    return response;
  } catch (error) {
    console.warn(error.message);
    const response = {
      status: false,
      data: {
        msg: error
      }
    };
    return response;
  }
}

/* below function is to get the lastname, pnr and email from the currentbookingInState and reset Group booking for normal booking */
export async function resetGroupBooking(currentBookingInState, paxDetails) {
  try {
    const response = {
      status: false,
      data: {}
    };
    if (currentBookingInState) {
      let isCancelFeeAdded = false;

      const ssrList = currentBookingInState.fees.length > 0 ? currentBookingInState.fees[0]?.value?.fees : [];
      const checkCancelAdhos = ssrList.filter((ssr) => ssr.code === CANCEL_BOOKING_FEE_CODE);
      if (checkCancelAdhos.length > 0) {
        isCancelFeeAdded = true;
      }
      if (currentBookingInState.journeys.length === 0) {
        isCancelFeeAdded = true;
      }
      if (currentBookingInState && isCancelFeeAdded) {
        response.status = true;
        await resetBookingAPI();
        await getToken(true);
        const bookingData = getPNRandLastNameFromBooking(currentBookingInState);
        const params = {
          pnrDetails: paxDetails?.recordLocator || bookingData.data.pnr,
          lastName: paxDetails?.lastName || bookingData.data.lastName,
          email: bookingData.data.email
        };

        response.data = await getBookingDetails(params);
      }
    }

    return response;
  } catch (error) {
    console.warn(error.message);
    const response = {
      status: false,
      data: {
        msg: error
      }
    };
    return response;
  }
}

export async function checkAndGetCurrentBookingInStateWithParams(params) {
  const responseData = await getBookingDetailsWithUserInfo(params);
  return responseData?.data?.data;
}

export async function checkAndGetCurrentBookingInState() {
  const response = await CurrentBookingInState();
  return response;
}

export const getAllCheckedInJourneys = (allJourneys) => {
  const checkedInArray = [];

  allJourneys?.forEach((journey) => {
    const checkedInSegments = journey?.segments?.filter((segment) => {
      const { passengerSegment } = segment;
      const checkedInPassengerList = passengerSegment?.filter(({ liftStatus }) => liftStatus === "CheckedIn" || liftStatus === "Boarded");

      return checkedInPassengerList?.length > 0;
    });

    if (checkedInSegments.length > 0) {
      checkedInArray.push(journey);
    }
  });

  return checkedInArray;
};

export const checkCheckedInPax = (allJourneys, segmentKey, paxKey, isGroupBooking = false) => {
  const checkedInArray = [];

  allJourneys?.forEach(({ segments }) => {
    segments?.forEach((segment) => {
      if (segment.segmentKey === segmentKey) {
        const { passengerSegment } = segment;

        // Filter the passenger segment based on the lift status and passenger key 
        const checkedInPassengerList = passengerSegment?.filter((paxSegment) => {
          const liftStatus = isGroupBooking ? paxSegment.liftStatus : paxSegment.value?.liftStatus; 
          const passengerKey = isGroupBooking ? paxSegment.passengerKey : paxSegment.value?.passengerKey; 
          return (liftStatus === "CheckedIn" || liftStatus === "Boarded") && passengerKey === paxKey;
        });

        // If there are checked-in passengers, push to the checkedInArray
        if (checkedInPassengerList?.length > 0) {
          checkedInArray.push(checkedInPassengerList);
        }
      }
    });
  });

  return checkedInArray.length > 0;
};

export const getUndoCheckInStatus = (allJourneys, undoCheckInBeforeTime) => {
  const segmentsEligibleForUndoCheckIn = [];

  const checkedInJourneys = getAllCheckedInJourneys(allJourneys);

  checkedInJourneys?.forEach((journey) => {
    const firstSegmentFlightDeparture = journey?.segments?.[0]?.designator?.departure;
    const timeEligibleForUndoCheckIn = moment(new Date()).add(undoCheckInBeforeTime, "m").toDate();

    if (moment(firstSegmentFlightDeparture).isAfter(timeEligibleForUndoCheckIn)) {
      segmentsEligibleForUndoCheckIn.push(journey);
    }
  });

  return segmentsEligibleForUndoCheckIn;
};

export const saveBookingInRedux = ({ currentBooking, refreshBookingData = false, dispatch }) => {
  dispatch(setCurrentBookingInState({ currentBookingInState: currentBooking }));
  dispatch(setInitBookingInState({ currentBookingInState: currentBooking }));
  if (refreshBookingData) {
    dispatch(resetAddhos());
    dispatch(resetPriceDiff());
  }
};